import React, { useEffect, useState, useRef } from 'react';
import p_nav_previous from '../../../Assets/Images/p_nav_previous.svg';  
import "./wallet.css"; 

import { useNavigate, useParams } from 'react-router-dom'; 
import NodeaxiosInstance from '../../../Services/nodeaxios';
import AddPingsOffcanvas from '../../../Components/offCanvas/addPingsOffcanvas'; 
import WalletTransactionCard from '../../../Components/cards/walletTransactionCard';

const VendorTokenHistory = () => {

    const navigate = useNavigate();
    let vendor_id = useParams()
    const [fil_type, set_fil_type] = useState(1);
    const [transactionHistory, setTransactionHistory] = useState([]);
    const [transactionHistoryRawData, setTransactionHistoryRawData] = useState([]);
    const [totalPage, setTotalPage] = useState()
    const [currentPage, setCurrentPage] = useState(1)
    const [loading, setLoading] = useState(false);
    const loaderRef = useRef(null);

    let scrollTimeout;

    const handleScroll = (e) => {
        if (scrollTimeout) return;

        scrollTimeout = setTimeout(() => {
            const { scrollTop, scrollHeight, clientHeight } = e.target;

            if (
                scrollTop + clientHeight >= scrollHeight - 50 &&
                !loading &&
                currentPage < totalPage
            ) {
                fetchTransactionHistory(currentPage + 1);
            }

            scrollTimeout = null;
        }, 200);
    };

    useEffect(() => {
        fetchTransactionHistory(1);
    }, []);

    const fetchTransactionHistory = async (page) => {
        if (loading) return;

        try {
            setLoading(true);

            let response = await NodeaxiosInstance.get(
                `/wallet/wallet-trasactions`,
                { params: { page: page, vendor_id: vendor_id?.vendor_id } }
            );

            if (response.status == 200) {
                const newData = response?.data?.userWalletTransactions || [];

                setCurrentPage(response?.data?.page);
                setTotalPage(response?.data?.totalPages);

                const updatedRaw = [...transactionHistoryRawData, ...newData];

                setTransactionHistoryRawData(updatedRaw);

                let filteredData = updatedRaw;

                if (fil_type === 2) {
                    filteredData = updatedRaw.filter(item => item.type === 'CREDIT');
                } else if (fil_type === 3) {
                    filteredData = updatedRaw.filter(item => item.type === 'DEBIT' || item?.reference_type === 'REVOKE');
                }

                setTransactionHistory(filteredData);
            }

        } catch (error) {
            console.error("Error fetching wallet-transactions:", error);
        } finally {
            setLoading(false);
        }
    };

    const tabList = [
        { id: 1, name: 'All' },
        { id: 2, name: 'Credited' },
        { id: 3, name: 'Debited' }
    ]

    useEffect(() => {
        let filteredData = transactionHistoryRawData;

        if (fil_type === 2) {
            filteredData = transactionHistoryRawData.filter(item => item.type === 'CREDIT');
        } else if (fil_type === 3) {
            filteredData = transactionHistoryRawData.filter(item => item.type === 'DEBIT' || item?.reference_type === 'REVOKE');
        }

        setTransactionHistory(filteredData);
    }, [fil_type, transactionHistoryRawData]);

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  offcanvas-parentType1">
                <div className="d-flex justify-content-between align-items-center  " onClick={() => navigate(-1)}>
                    <img src={p_nav_previous} alt="Previous Button" role="button" width={'24px'} height={'16px'} />
                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>History</div>
                </div>
            </div>
            <div className="px-3 py-1  bg-white d-flex flex-column" style={{ height: "calc(100dvh - 62px)" }}>
                <div className="wallet_history_search_container">
                    <div className="wallet_history_searchOptionsList">
                        {tabList?.map((item) => (
                            <div key={item.id} className={`wallet_history_search_option  ${fil_type == item.id ? "active primary-text" : ""}`} role="button"
                                onClick={() => set_fil_type(item.id)}  >
                                {item?.name}
                            </div>
                        ))}
                    </div>
                </div>

                <div className="scroller-style-y pb-5 flex-grow-1" onScroll={handleScroll}>
                    <div>
                        {transactionHistory.length > 0 ?
                            transactionHistory.map((item, index) => (
                                <WalletTransactionCard key={index} item={item} />
                            )) :
                            <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: '70vh' }}>
                                <span className="ff-poppins-medium fs-13">
                                    No Transaction Found
                                </span>
                            </div>
                        }
                    </div>
                    <div ref={loaderRef} className="text-center fs-poppins-regular fs-14 py-3 py-3">
                        {loading && <p>Loading...</p>}
                    </div>
                </div>
            </div>
        </div>
    )
}
export default VendorTokenHistory;

